import React from 'react'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'
import { modalScheduleSendingState } from '../../recoil/state/modals'
import { sendingScheduleSetScheduleCallback } from '../../recoil/callbacks/callbacks'
import { ModalBody } from 'mailup-web-components'
import { Foot } from './Foot'
import { STORE_KEY_LIST } from 'Constants'
import { useStorage } from 'Hooks/'
import { ContentScheduled } from 'Components/ContentScheduled/ContentScheduled'
import {
  contentScheduledState,
  isValidDateState,
  setBoxErrorState
} from 'Components/ContentScheduled/recoil/state'
import { verifyDateCallback } from 'Components/ContentScheduled/recoil/callbacks'
import { MODE_SMART } from 'Constants/index'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'

export const ModalContentScheduled = ({ mode }) => {
  const intl = useIntl()
  const [{ TimeZoneCode: listTimeZoneCode }] = useStorage(STORE_KEY_LIST).values
  const {
    idSending,
    date: scheduleDate,
    timeZoneCode: scheduleTimeZoneCode,
    startDateSmart,
    timeZoneCodeSmart
  } = useRecoilValue(modalScheduleSendingState)
  const confirm = useRecoilCallback(sendingScheduleSetScheduleCallback, [])
  const cancel = useResetRecoilState(modalScheduleSendingState)

  const { momentUtcDate, momentTimeZoneDate, timeZone } = useRecoilValue(
    contentScheduledState
  )
  const verifyDate = useRecoilCallback(verifyDateCallback, [])
  const setBoxError = useSetRecoilState(setBoxErrorState)

  const isValidDate = useRecoilValue(isValidDateState)

  return (
    <>
      <ModalBody>
        <ContentScheduled
          scheduleDate={mode === MODE_SMART ? startDateSmart : scheduleDate}
          scheduleTimeZoneCode={
            mode === MODE_SMART
              ? timeZoneCodeSmart
              : scheduleTimeZoneCode || listTimeZoneCode
          }
          dateDisabled={mode === MODE_SMART}
          hoursDisabled={mode === MODE_SMART}
          minutesDisabled={mode === MODE_SMART}
          timeZoneDisabled={mode === MODE_SMART}
          mode={mode}
          description={
            mode === MODE_SMART
              ? intl.formatMessage({
                  id: 'Load.QueueStatus.AiPlanningDescription'
                })
              : undefined
          }
        />
      </ModalBody>
      <Foot
        disabled={!isValidDate}
        onClickCancel={cancel}
        onClickConfirm={async () => {
          const { valid } = await verifyDate(momentTimeZoneDate)
          if (valid) {
            const planningType = mode === MODE_SMART ? 1 : 0
            confirm(idSending, momentUtcDate, timeZone, planningType)
          } else {
            setBoxError(true)
          }
        }}
      />
    </>
  )
}

ModalContentScheduled.propTypes = {
  mode: PropTypes.string
}
